import React, { useEffect, useState } from 'react';
import { authService } from '../../api';
import { useNavigate, Link } from 'react-router-dom';
import EvenementInscriptionUser from './EvenementInscriptionUser';
import { 
  FaUser, 
  FaBullhorn, 
  FaEnvelope, 
  FaCalendarAlt, 
  FaCog,
  FaMapMarkerAlt,
  FaInfoCircle,
  FaLightbulb,
  FaHandsHelping,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaLinkedin,
  FaGlobe,
  FaGraduationCap,
  FaBriefcase,
  FaEdit,
  FaPhone,
  FaEuroSign,
  FaIndustry,
  FaCamera // Icône ajoutée pour l'image
} from 'react-icons/fa';
import AnnonceUser from './AnnonceUser';
import MessageUser from './MessageUser';
import './UserSpace.css';

const UserSpace = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('profil');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await authService.getProfile();
        const userWithImage = { ...response };

// MÊME LOGIQUE QUE ListeExperts
if (response.image || response.image_url) {
  const imagePath = response.image || response.image_url;
  userWithImage.imageUrl = getImageUrl(imagePath);
} else {
  userWithImage.imageUrl = null;
}

setUserData(userWithImage);

      } catch (err) {
        setError(err.message || 'Erreur lors du chargement des données');
        console.error('Erreur:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const getInitials = (name) => {
    return name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : '';
  };


  const getDisplayImageUrl = () => {
  if (imageError) return null;
  return userData?.imageUrl || null;
};

  // Fonction pour obtenir l'URL de l'image - CORRIGÉ POUR PRODUCTION
 // Fonction pour obtenir l'URL de l'image - CORRIGÉ
const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    
    // Si c'est déjà une URL complète
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }
    
    // Utiliser la variable d'environnement
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    
    // Nettoyer le chemin si nécessaire
    const cleanedPath = imagePath.startsWith('storage/') 
      ? imagePath.replace('storage/', '') 
      : imagePath;
    
    // Même logique que dans ListeExperts.js
    if (cleanedPath.includes('/')) {
        // Si le chemin contient déjà un dossier (ex: "annonces/filename.jpg")
        return `${baseUrl}/storage/${cleanedPath}`;
    } else {
        // Sinon, utiliser 'annonces' par défaut
        return `${baseUrl}/storage/annonces/${cleanedPath}`;
    }
};

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setMobileMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
      navigate('/');
    } catch (err) {
      console.error('Erreur lors de la déconnexion:', err);
    }
  };

  // Fonction pour parser les données JSON stockées en chaînes
  const parseJsonField = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    try {
      return JSON.parse(field);
    } catch (e) {
      console.error('Erreur lors du parsing JSON:', e);
      return [];
    }
  };

  if (loading) return <div className="loading">Chargement...</div>;
  if (error) return <div className="error">Erreur: {error}</div>;
  if (!userData) return <div className="error">Aucune donnée utilisateur</div>;

  // Vérifier si l'utilisateur a une image
  const hasImage = userData.image || userData.image_url;

  return (
    <div className="user-dashboardprofile">
      {/* Sidebar */}
      <div className="sidebaruser">
        <div className="user-headeruser">
          <div className="avatar-circle">
            {hasImage ? (
              <img 
                src={getImageUrl(userData.image_url || userData.image)} 
                alt="Profil" 
                className="profile-image-sidebar"
                onError={(e) => {
                  // Fallback si l'image ne charge pas
                  
                }}
              />
            ) : (
              getInitials(userData.name || userData.nom_entreprise)
            )}
          </div>
          <h3 className="username">{userData.name || userData.nom_entreprise}</h3>
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <nav className={`sidebar-nav ${mobileMenuOpen ? 'active' : ''}`}>
          <ul>
            <li 
              className={activeTab === 'profil' ? 'active' : ''}
              onClick={() => handleTabChange('profil')}
            >
              <FaUser className="icon" /> Mon profil
            </li>
            <li 
              className={activeTab === 'annonces' ? 'active' : ''}
              onClick={() => handleTabChange('annonces')}
            >
              <FaBullhorn className="icon" /> Mes annonces
            </li>
            <li 
              className={activeTab === 'messages' ? 'active' : ''}
              onClick={() => handleTabChange('messages')}
            >
              <FaEnvelope className="icon" /> Messages
            </li>
            <li 
              className={activeTab === 'evenements' ? 'active' : ''}
              onClick={() => handleTabChange('evenements')}
            >
              <FaCalendarAlt className="icon" /> Événements
            </li>
            <li onClick={handleLogout} className="logout-item">
              <FaSignOutAlt className="icon" /> Déconnexion
            </li>
          </ul>
        </nav>
      </div>

      {/* Main Content */}
      <div className="main-contentuser">
        {activeTab === 'profil' && (
          <div className="profile-section">
            <div className="profile-header-section">
              <h1>Mon profil</h1>
              <button 
                className="edit-profile-btn"
                onClick={() => navigate('/modifier-profil')}
              >
                <FaEdit /> Modifier mon profil
              </button>
            </div>
            
            <div className="profile-layout">
              {/* Carte de profil à gauche */}
              <div className="profile-card-main">
                <div className="profile-identity">
                  <div className="avatar-circle large">
                  {getDisplayImageUrl() ? (
  <img 
    src={getDisplayImageUrl()}
    alt="Profil"
    className="profile-image-sidebar"
    onError={() => setImageError(true)}
  />
) : (
  getInitials(userData.name || userData.nom_entreprise)
)}

                  </div>
                  <div className="identity-info">
                    <h2>{userData.name || userData.nom_entreprise}</h2>
                    <p className="role-badge">{userData.role}</p>
                    {userData.bio && (
                      <p className="profile-bio">{userData.bio}</p>
                    )}
                    {/* Badge d'image si présente */}
                    {hasImage && (
                      <div className="image-badge">
                        <FaCamera /> Photo de profil
                      </div>
                    )}
                  </div>
                </div>

                {/* Informations de contact */}
                <div className="contact-info">
                  <h3>Informations de contact</h3>
                  <div className="contact-list">
                    <div className="contact-item">
                      <FaEnvelope className="contact-iconprofil" />
                      <div>
                        <span className="contact-label">Email</span>
                        <span className="contact-value">{userData.email}</span>
                      </div>
                    </div>
                    {userData.telephone && (
                      <div className="contact-item">
                        <FaPhone className="contact-iconprofil" />
                        <div>
                          <span className="contact-label">Téléphone</span>
                          <span className="contact-value">{userData.telephone}</span>
                        </div>
                      </div>
                    )}
                    {userData.ville && (
                      <div className="contact-item">
                        <FaMapMarkerAlt className="contact-iconprofil" />
                        <div>
                          <span className="contact-label">Ville</span>
                          <span className="contact-value">{userData.ville}</span>
                        </div>
                      </div>
                    )}
                    {/* Afficher l'URL de l'image si disponible */}
                    {hasImage && (
                      <div className="contact-item">
                        <FaCamera className="contact-iconprofil" />
                        <div>
                          <span className="contact-label">Image</span>
                          <span className="contact-value truncate">
                            <a 
                              href={getDisplayImageUrl()}

                              target="_blank" 
                              rel="noopener noreferrer"
                              className="image-link"
                            >
                              Voir l'image
                            </a>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Liens et réseaux sociaux */}
                {(userData.linkedin || userData.site_internet) && (
                  <div className="links-section">
                    <h3>Liens</h3>
                    <div className="links-list">
                      {userData.linkedin && (
                        <a href={userData.linkedin} target="_blank" rel="noopener noreferrer" className="link-item">
                          <FaLinkedin className="link-icon" />
                          <span>LinkedIn</span>
                        </a>
                      )}
                      {userData.site_internet && (
                        <a href={userData.site_internet} target="_blank" rel="noopener noreferrer" className="link-item">
                          <FaGlobe className="link-icon" />
                          <span>Site web</span>
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Détails du profil à droite */}
              <div className="profile-details">
                {/* Informations spécifiques par rôle */}
                {userData.role === 'expert' && (
                  <div className="details-grid">
                    {userData.prenom && (
                      <div className="detail-card">
                        <FaUser className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Prénom</h4>
                          <p>{userData.prenom}</p>
                        </div>
                      </div>
                    )}
                    {userData.tarif && (
                      <div className="detail-card">
                        <FaEuroSign className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Tarif</h4>
                          <p>{userData.tarif}</p>
                          {userData.prix && <span className="price">{userData.prix}€</span>}
                        </div>
                      </div>
                    )}
                    {userData.region_couverte && (
                      <div className="detail-card">
                        <FaMapMarkerAlt className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Région couverte</h4>
                          <p>{userData.region_couverte}</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {userData.role === 'entreprise' && (
                  <div className="details-grid">
                    {userData.siret && (
                      <div className="detail-card">
                        <FaBriefcase className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>SIRET</h4>
                          <p>{userData.siret}</p>
                        </div>
                      </div>
                    )}
                    {userData.secteur_activite && (
                      <div className="detail-card">
                        <FaIndustry className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Secteur d'activité</h4>
                          <p>{userData.secteur_activite}</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {userData.role === 'etudiant' && (
                  <div className="details-grid">
                    {userData.prenom && (
                      <div className="detail-card">
                        <FaUser className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Prénom</h4>
                          <p>{userData.prenom}</p>
                        </div>
                      </div>
                    )}
                    {userData.niveau_etude && (
                      <div className="detail-card">
                        <FaGraduationCap className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Niveau d'étude</h4>
                          <p>{userData.niveau_etude}</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {userData.role === 'mentor' && (
                  <div className="details-grid">
                    {userData.prenom && (
                      <div className="detail-card">
                        <FaUser className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Prénom</h4>
                          <p>{userData.prenom}</p>
                        </div>
                      </div>
                    )}
                    {userData.specialite_etudes && (
                      <div className="detail-card">
                        <FaGraduationCap className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Spécialité d'études</h4>
                          <p>{userData.specialite_etudes}</p>
                        </div>
                      </div>
                    )}
                    {userData.secteur_pro && (
                      <div className="detail-card">
                        <FaIndustry className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Secteur professionnel</h4>
                          <p>{userData.secteur_pro}</p>
                        </div>
                      </div>
                    )}
                    {userData.annee_arrivee_fr && (
                      <div className="detail-card">
                        <FaCalendarAlt className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Arrivée en France</h4>
                          <p>{userData.annee_arrivee_fr}</p>
                        </div>
                      </div>
                    )}
                    {userData.region_couverte && (
                      <div className="detail-card">
                        <FaMapMarkerAlt className="detail-card-icon" />
                        <div className="detail-card-content">
                          <h4>Région couverte</h4>
                          <p>{userData.region_couverte}</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Sections avec tags */}
                <div className="tags-sections">
                  {userData.services && parseJsonField(userData.services).length > 0 && (
                    <div className="tags-section">
                      <h3>
                        <FaBriefcase className="section-title-icon" />
                        Services
                      </h3>
                      <div className="tags-container">
                        {parseJsonField(userData.services).map((service, index) => (
                          <span key={index} className="tag">{service}</span>
                        ))}
                      </div>
                    </div>
                  )}

                  {userData.modes_accompagnement && parseJsonField(userData.modes_accompagnement).length > 0 && (
                    <div className="tags-section">
                      <h3>
                        <FaHandsHelping className="section-title-icon" />
                        Modes d'accompagnement
                      </h3>
                      <div className="tags-container">
                        {parseJsonField(userData.modes_accompagnement).map((mode, index) => (
                          <span key={index} className="tag">{mode}</span>
                        ))}
                      </div>
                    </div>
                  )}

                  {userData.besoins && parseJsonField(userData.besoins).length > 0 && (
                    <div className="tags-section">
                      <h3>
                        <FaHandsHelping className="section-title-icon" />
                        Besoins
                      </h3>
                      <div className="tags-container">
                        {parseJsonField(userData.besoins).map((besoin, index) => (
                          <span key={index} className="tag">{besoin}</span>
                        ))}
                      </div>
                    </div>
                  )}

                  {userData.competences && parseJsonField(userData.competences).length > 0 && (
                    <div className="tags-section">
                      <h3>
                        <FaLightbulb className="section-title-icon" />
                        Compétences
                      </h3>
                      <div className="tags-container">
                        {parseJsonField(userData.competences).map((comp, index) => (
                          <span key={index} className="tag">{comp}</span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Flèche de retour */}
            <Link to="/" className="home-arrow">
              <div className="arrow-icon">←</div>
            </Link>
          </div>
        )}

        {activeTab === 'annonces' && <AnnonceUser />}
        {activeTab === 'messages' && <MessageUser />}
        {activeTab === 'evenements' && <EvenementInscriptionUser />}
      </div>
    </div>
  );
};

export default UserSpace;